module.exports = __webpack_public_path__ + "static/media/active-search.e0ea3d18.svg";